import clsx from 'clsx'
import type { ComponentProps } from 'react'
import {
  historyItemContent,
  historyItemContentEmbedded
} from '../ApplicantHistory.css'
import { useHistoryContext } from '../HistoryContext'

export const HistoryItemContent = ({
  className,
  ...props
}: ComponentProps<'div'>) => {
  const { embedded } = useHistoryContext()

  return (
    <div
      className={clsx(
        historyItemContent,
        embedded && historyItemContentEmbedded,
        className
      )}
      {...props}
    />
  )
}
